import { forwardRef } from "react";
import DateTimePicker, { PICKER_MODE } from "./DateTimePicker";
import { TimeFormatType } from "interfaces/models/inspectionItemResult";

interface Props {
  formatType: TimeFormatType;
  isReadOnly?: boolean;
  value: string | undefined | null;
  placeholderText?: string;
  showIcon?: boolean;
  isLoading?: boolean;
  inputStyle?: React.CSSProperties;
  isShowTooltip?: boolean;
  clearIconFontSize?: string;
  isShowCalendar?: boolean;
  setIsShowCalendar: (val: boolean) => void;
  onChangeStatusValidTime?: (val: boolean) => void;
  onChange:
    | ((value?: string | null | undefined) => Promise<boolean | undefined>)
    | undefined;
}

export interface TimePickerRef {
  focusInput: () => void;
}

const TimePicker = forwardRef<TimePickerRef, Props>((props: Props, ref) => {
  const { onChangeStatusValidTime, ...restProps } = props;
  
  return (
    <DateTimePicker
      mode={PICKER_MODE.TIME}
      ref={ref}
      {...restProps}
      onChangeStatusValid={onChangeStatusValidTime}
    />
  );
});

export default TimePicker;
